import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface OfficeEditorViewProps {
	officeRequest: DropdownRequest<TransportCompanyOfficeItem>;
	value: number | null;
	mode: ControlMode;
	onChanged: (number: TransportCompanyOfficeItem) => void;
	label?: string;
    supplierId?: number;
	required?: boolean;
}

export class OfficeEditorView extends React.Component<OfficeEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label == null) {
			label = 'Office';
		}
		
		return (
			<DropdownView
                label={label}
                required={this.props.required}
				model={this.props.value}
				disabled={this.props.mode == 'display'}
				onChanged={this.props.onChanged}
				request={this.props.officeRequest}
				keyField="id"
				textField="title"
				cascadeValue={this.props.supplierId}
				cascadeField="supplierId"
			
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-editor.view.tsx